import { CampaignComponentFragment, Offer_Engagement_Type } from '@occc/graphql';
import config from '@occc/config';
import { getOfferComponentType } from '@occc-app/offerHelpers/utils';

import { CampaignComponent } from './types';

export const getIsCampaignComponentDisabled = (offer: CampaignComponentFragment): boolean => {
  if (
    offer.engagementType === Offer_Engagement_Type.Promocode &&
    !config.features.promocodesOffersEnabled
  ) {
    return true;
  }

  // Add more conditions here if needed

  return false;
};

export const mapCampaignComponent = (item: CampaignComponentFragment): CampaignComponent => {
  const {
    id,
    name,
    description,
    marketingContents,
    deleted,
    fulfillmentCount,
    earningMechanism,
    publishedStatus,
  } = item;

  const disabled = getIsCampaignComponentDisabled(item);

  return {
    id,
    name,
    description: description ?? null,
    marketingContent: marketingContents?.[0] || null,
    type: getOfferComponentType(item),
    // publishAt / expireAt are not requested by the campaignComponent fragment.
    publishAt: null,
    expireAt: null,
    deleted,
    fulfillmentCount,
    earningMechanism,
    publishedStatus,
    disabled,
  };
};
